import call from "../../http";
import { AuthConstants } from "./index";
import AuthService from "./AuthService";
import { apiBaseUrl } from "@/environment";
import axios from "axios";
import Helper from "../../utils/helpers/Helper";

export default {
  namespaced: true,
  state: {
    error: "",
    user: {}
  },
  mutations: {
    SET_ERROR: (state, payload) => {
      state.error = payload;
    },
    SET_CURRENT_USER: (state, payload) => {
      state.user = payload;
    }
  },
  actions: {
    signUp: async (context, data) => {
      context.commit("SET_ERROR", "");
      Event.$emit("loading", true);
      try {
        const res = await call("post", AuthConstants.user, data);
        const token = res?.data?.data?.response?.data?.accesstoken;
        axios
          .get(`${apiBaseUrl}user`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
          .then(res => {
            const user = res?.data;
            AuthService.register(token, user);
            AuthService.setUser(user);
            Event.$emit("loading", false);
          })
          .catch(() => {
            context.commit("SET_ERROR", "Error while registering");
            Event.$emit("loading", false);
          });
      } catch (err) {
        const error = Helper.errors(err.response.data);
        context.commit("SET_ERROR", error);
        Event.$emit("loading", false);
      }
    },

    login: async ({ commit }, data) => {
      Event.$emit("loading", true);
      commit("SET_ERROR", "");
      try {
        const response = await call("post", AuthConstants.login, data);
        const token = response.data.data.response.data.access_token;
        axios
          .get(`${apiBaseUrl}user`, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          })
          .then(res => {
            const roleId = res?.data?.roles[0]?.id;
            const user = res?.data;
            if (roleId && roleId === 2) {
              AuthService.login(token, user);
              AuthService.setUser(user);
              Event.$emit("loading", false);
            } else {
              commit("SET_ERROR", "Access Denied");
              Event.$emit("loading", false);
            }
          })
          .catch(() => {
            commit(
              "SET_ERROR",
              "You don't have a role or your role is inactive"
            );
            Event.$emit("loading", false);
          });
      } catch (err) {
        const error = Helper.errors(err.response.data);
        commit("SET_ERROR", error);
        Event.$emit("loading", false);
      }
    },

    forgotPassword: async (context, data) => {
      Event.$emit("loading", true);
      context.commit("SET_ERROR", "");

      try {
        await call("post", AuthConstants.forgotPassword, data);
        Event.$emit("loading", false);

        Event.$emit("forgotPassword-success");
      } catch (err) {
        const error = Helper.errors(err.response.data);
        context.commit("SET_ERROR", error);
        Event.$emit("loading", false);
      }
    },

    resetPassword: async (context, data) => {
      Event.$emit("loading", true);
      context.commit("SET_ERROR", "");

      try {
        await call("post", AuthConstants.setPassword, data);
        Event.$emit("loading", false);
        Event.$emit("reset-success");
      } catch (err) {
        const error = Helper.errors(err.response.data);
        context.commit("SET_ERROR", error);
        Event.$emit("loading", false);
      }
    },

    getUser: () => {
      call("get", AuthConstants.getUser).then(res => {
        AuthService.setUser(res.data);
        Event.$emit("loading", false);
      });
    }
  },
  getters: {
    error: state => state.error
  }
};
